import { ITerm } from './index';

const TERM_NOTI: ITerm[] = [
  {
    text: '[알림 서비스] 개인정보 수집·이용 동의(필수)',
    guideText: '[알림 서비스] 항목은 필수입니다.',
    required: true,
    termCd: 'NOTI_1',
    type: 'term',
    path: '/terms/NOTI_1.html',
    subTextItem: [],
  },
  {
    text: '[알림 서비스] 개인정보 제 3자 제공 동의(필수)',
    guideText: '[알림 서비스] 항목은 필수입니다.',
    required: true,
    termCd: 'NOTI_2',
    type: 'term',
    path: '/terms/NOTI_2.html',
    subTextItem: [],
  },
];
export default TERM_NOTI;
